module.exports = __webpack_public_path__ + "img/settings_menu_docsign.5d621cbc.png";